import { TrendingUp, Plus } from "lucide-react";

import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/shared/EmptyState";
import InvestimentoRow from "./InvestimentoRow";

// FIN-4 — InvestimentoTable.
// Variant table (md+) com 8 colunas + variant compact (<md).

const COLUMNS = [
  { id: "name",         label: "Nome",          align: "text-left" },
  { id: "type",         label: "Tipo",          align: "text-left" },
  { id: "qty",          label: "Qtd",           align: "text-left" },
  { id: "price",        label: "Preço médio",   align: "text-left" },
  { id: "current",      label: "Valor atual",   align: "text-left" },
  { id: "total",        label: "Total",         align: "text-left" },
  { id: "gain",         label: "Ganho/Perda",   align: "text-left" },
  { id: "institution",  label: "Instituição",   align: "text-right" },
];

function SkeletonRow() {
  return (
    <tr className="border-b border-subtle/30 animate-pulse">
      {COLUMNS.map((c, i) => (
        <td key={c.id} className="py-3 px-3">
          <div className={`h-3 bg-surface-card-hover rounded ${i === 0 ? "w-32" : "w-16"}`} />
        </td>
      ))}
    </tr>
  );
}

export default function InvestimentoTable({
  investments,
  isLoading,
  onTalk,
  onEdit,
  onDelete,
  onUpdateCurrent,
  onCreate,
  hasActiveFilter,
}) {
  if (!isLoading && investments.length === 0) {
    return (
      <Card variant="elevated" className="glass-card py-12 px-6" data-testid="invest-table-empty">
        <EmptyState
          icon={TrendingUp}
          title={hasActiveFilter ? "Sem investimentos nesta classe" : "Nenhum investimento adicionado"}
          description={hasActiveFilter
            ? "Tente outra classe ou limpe o filtro pra ver tudo."
            : "Cadastre seus ativos pra acompanhar rentabilidade e diversificação."}
          action={!hasActiveFilter && onCreate ? (
            <Button variant="primary" size="md" onClick={onCreate} data-testid="invest-empty-cta">
              <Plus className="w-4 h-4" /> Adicionar investimento
            </Button>
          ) : null}
        />
      </Card>
    );
  }

  return (
    <>
      {/* MD+ table */}
      <Card variant="elevated" className="glass-card overflow-hidden hidden md:block" data-testid="invest-table">
        <div className="overflow-x-auto">
          <table className="w-full text-caption">
            <thead className="sticky top-0 z-10 bg-surface-overlay/95 backdrop-blur border-b border-subtle">
              <tr>
                {COLUMNS.map(c => (
                  <th
                    key={c.id}
                    className={`py-3 px-3 text-foreground-muted text-micro font-semibold uppercase ${c.align}`}
                    style={{ letterSpacing: "0.10em" }}
                  >
                    {c.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {isLoading && investments.length === 0 ? (
                <>
                  <SkeletonRow />
                  <SkeletonRow />
                  <SkeletonRow />
                </>
              ) : (
                investments.map(inv => (
                  <InvestimentoRow
                    key={inv.id}
                    inv={inv}
                    onTalk={onTalk}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onUpdateCurrent={onUpdateCurrent}
                    variant="table"
                  />
                ))
              )}
            </tbody>
          </table>
        </div>
      </Card>

      {/* Mobile compact */}
      <div className="md:hidden flex flex-col gap-2.5" data-testid="invest-table-compact">
        {isLoading && investments.length === 0 ? (
          <div className="glass-card rounded-xl p-4 text-caption text-foreground-muted text-center">carregando…</div>
        ) : (
          investments.map(inv => (
            <InvestimentoRow
              key={inv.id}
              inv={inv}
              onTalk={onTalk}
              onEdit={onEdit}
              onDelete={onDelete}
              onUpdateCurrent={onUpdateCurrent}
              variant="compact"
            />
          ))
        )}
      </div>
    </>
  );
}
